import { cx } from "@light-technology/components";
import type { ReactNode } from "react";

type ViewOnlyFieldProps = {
  label: ReactNode;
  value: ReactNode;
  description?: ReactNode;
  className?: string;
};

export const ViewOnlyField = ({
  label,
  value,
  description,
  className,
}: ViewOnlyFieldProps) => {
  return (
    <div className={cx("flex flex-col gap-sm", className)}>
      <div className="text-sm font-medium text-secondary">{label}</div>
      <span className="text-md text-primary">{value}</span>
      {description ? (
        <div className="text-sm text-tertiary">{description}</div>
      ) : null}
    </div>
  );
};
